import { find } from 'lodash';
import {
  object, number, boolean, array,
  string,
} from 'yup';
import '@client/yup';

export const PaidTicketModalSchema = object().shape({
  prices: array().of(
    object().shape({
      quantity: number().min(0),
      ticketPrice: string().minimumPrice(),
      minimumPrice: number().min(0),
      hasVariablePrice: boolean().required(),
    }),
  ).test('has-ticket', 'You need to select a ticket to continue', (values) => !!find(values, (value) => {
    if (!value.hasVariablePrice && value.quantity > 0) {
      return true;
    }

    return value.quantity && (value.ticketPrice || value.minimumPrice);
  })),
});

export const PaidTicketModalGuestSchema = PaidTicketModalSchema.concat(object().shape({
  acceptsTos: boolean().required().oneOf([true], 'Field must be checked'),
}));
